import { Api, APIEnvironments } from '@evertel/api'


class ApiWeb extends Api {
    static LOG_NONE = ''
    static LOG_V = 'v'
    static LOG_VV = 'vv'

    public logLevel = ''

    constructor(
        useApi: APIEnvironments,
        withCredentials: boolean,
        platform: string,
        buildNumber: string
    ) {
        super(
            useApi,
            withCredentials,
            platform,
            buildNumber
        )
    }
}

export { ApiWeb }
